import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'stamps';

const createStamp = async (body) => {
  const method = 'POST';
  const url = `${USE_CASE_URL}`;

  const json = await request({ method, url, body });
  return json;
};

export default createStamp;
